import AboutJosh from "../../components/About/About-Josh";
import AboutWork from "../../components/About/About-Work";

export default function AboutPage() {
  return (
    <div>
      <div className="homepage-bodycontent">
        <AboutJosh />
        <AboutWork />
      </div>
    </div>
  );
}
